/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {RecipeListSectionSkeleton} from "./RecipeListSectionSkeleton";
import {RecipeListHeaderSkeleton} from "./RecipeListHeaderSkeleton";
import {RecipeListButtonSkeleton} from "./RecipeListButtonSkeleton";

export const RecipeListSkeleton = () => (
    <>
        <RecipeListHeaderSkeleton/>
        {[...Array(3)].map((item, i) => <RecipeListSectionSkeleton key={i}/>)}
        <RecipeListButtonSkeleton/>
    </>
)
